import {
	DynamicPermissionCode,
	TwoFactorAuthorizationStatus
} from 'Services/Api/Users/Types';
import Layout from './Layout';
import { useTranslation } from 'react-i18next';
import { Permission } from 'Components';
import { EditUserValues } from 'Pages/User/User.types';
import { useFormikContext } from 'formik';

type Props = {
	isProfile: boolean;
	twoFactorAuthenticationStatus: TwoFactorAuthorizationStatus;
	openModal: () => void;
};
const MFASettings = ({
	isProfile,
	twoFactorAuthenticationStatus,
	openModal
}: Props) => {
	const { t } = useTranslation();
	const { values } = useFormikContext<EditUserValues>();
	const isMFAEnabled =
		twoFactorAuthenticationStatus === TwoFactorAuthorizationStatus.Setup;
	const btnText = isMFAEnabled ? 'enabled' : 'disabled';

	return (
		<Permission
			dynamicCode={DynamicPermissionCode.Reset2Fa}
			dynamicCodeRole={values.primarySystemRoleId?.[0]?.label?.toLowerCase()}
		>
			{({ permitted }) => {
				const isActive =
					permitted &&
					!isProfile &&
					(isMFAEnabled ||
						twoFactorAuthenticationStatus ===
							TwoFactorAuthorizationStatus.Blocked);
				return (
					<Layout
						parentClass={`mfa-section`}
						title={t(`profile.mfa.title`)}
						description={t(`profile.mfa.description`)}
						btnText={isActive ? t('profile.mfa.btnText') : ''}
						handleNext={openModal}
					>
						<div className={`mfa-status ${btnText}`}>
							{t(`profile.notifications.${btnText}`)}
						</div>
					</Layout>
				);
			}}
		</Permission>
	);
};

export default MFASettings;
